export default {
  state: {
    user: {id: 0, name: '', client_id: 0, sub_user_id: 0, rights: {}, token: ''},
    notification: [],
    roles: [
      /* {id: 1, name: 'Админ'},
      {id: 2, name: 'Менеджер'},
      {id: 3, name: 'Оператор'} */
    ],
    sip_settings: {}
  },
  mutations: {
    addNotification (state, payload) {
      state.notification.push(payload)
    },
    addRoles (state, payload) {
      state.roles.push(payload)
    },
    setUser (state, payload) {
      state.user = payload
    },
    setRoles (state, payload) {
      state.roles = payload
    },
    setSIP (state, payload) {
      state.sip_settings = payload
    }
  },
  actions: {
    addNotification ({commit}, payload) {
      commit('addNotification', payload)
    },
    addRoles ({commit}, payload) {
      commit('addRoles', payload)
    },
    setUser ({commit}, payload) {
      commit('setUser', payload)
    },
    setRoles ({commit}, payload) {
      commit('setRoles', payload)
    },
    setSIP ({commit}, payload) {
      commit('setSIP', payload)
    }
  },
  getters: {
    user (state) {
      return state.user
    },
    client_id (state) {
      if (state.user.client_id > 0) {
        return state.user.client_id
      }
      return state.user.id
    },
    notification (state) {
      return state.notification
    },
    roles (state) {
      return state.roles
    },
    sip_settings (state) {
      return state.sip_settings
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/currentUser.js